module.exports = __webpack_public_path__ + "static/media/min_white.b2dafc5d.png";